import { AxiosInstance } from 'axios'
import { Dispatch } from 'redux'
import { IBrukare } from '../features/brukare'
import { ISetBrukareAction, setBrukareAction } from '../features/brukare/store/actions'

// Löpnummer för listans hämtningar – bara svaret på den senaste frågan hamnar i listan (#101).
// Två frågor kan vara ute samtidigt (byte av period, omhämtning efter hantering) och svaren kan
// komma i omvänd ordning. Utan numret visades det svar som kom sist, ibland för en annan period
// än den som står i periodväljaren. Numret ligger här och inte på sidan, eftersom alla som hämtar
// listan skriver till samma ställe i Redux.
let senasteFråga = 0

export const setBrukare = async (api: AxiosInstance, dispatch: Dispatch<ISetBrukareAction>, date?: { from: string; to: string }) => {
  let from
  let to

  if (date) {
    from = date.from
    to = date.to
  } else {
    from = '2020-01-01'
    to = '2021-12-31'
  }

  const nr = ++senasteFråga
  try {
    const brukare = await api.get<IBrukare[]>(`/v1/brukare/${localStorage.getItem('tenant_id')}/all?from=${from}&to=${to}&id_token=${localStorage.getItem('hydra_id_token')}`, {
      headers: {
        authorization: 'Bearer ' + localStorage.getItem('hydra_access_token'),
      },
    })

    if (nr !== senasteFråga) return

    if (brukare.data === []) {
      setBrukareAction('SET_BRUKARE', [], dispatch)
      return
    }

    const formattedData = brukare.data.map((item: IBrukare) => {
      console.log(item.förnamn)
      return {
        key: item.id,
        flagga: item.flagga,
        flaggnamn: item.flaggnamn,
        nivå: item.nivå,
        namn: item.förnamn + ' ' + item.efternamn,
        personnummer: item.personnummer,
        från: item.från,
        till: item.till,
        created: item.created,
        utförare: item.utförare,
        ansvarig_handläggare: item.ansvarig_handläggare,
        hantering: item.hantering,
      }
    })

    return setBrukareAction('SET_BRUKARE', formattedData, dispatch)
  } catch (err) {
    console.log(err)
  }
}
